<div class="d-flex justify-content-center" style="height: 100vh; width: 100%; background-image: url('assets/bg.jpg'); background-repeat: no-repeat; background-size: cover;">

    <div class="col-6 mx-auto align-self-center">
        <div class="card">
            <div class="card-body">
                <form class="" #fpForm="ngForm" (ngSubmit)="changeFirstPassword(fpForm.value)">
                    <div class="text-center mb-3">
                        <img src="assets/logo.png" class="img-fluid" alt="" style="height: 80px;">

                    </div>
                    <div class="form-row">
            <div class="col-md-12">
                <div class="position-relative form-group">
                    <label for="exampleEmail1" class="">Nouveau mot de passe</label>
                    <input name="password" id="exampleEmail1" placeholder="Mot de passe ici..." type="password" class="form-control" ngModel required>
                    </div>
            <div class="position-relative form-group">
            <label for="exampleEmail2" class="">Confirmer mot de passe</label>
            <input name="confirm_password" id="exampleEmail2" placeholder="Mot de passe ici..." type="password" class="form-control" ngModel required>
            </div>
            </div>
            </div>
            <div class="mt-4 d-flex align-items-center">
          
            <div class="ml-auto">
            <button class="btn btn-primary btn-lg" [disabled]="fpForm.invalid || loading" type="submit">Changer mon mot de passe <app-loading [isVisible]="loading"></app-loading></button>
            </div>
            </div>
            </form>
            </div>
        </div>
    </div>
</div>
